export default "__VITE_ASSET__BnnmF7LU__"